var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsgDropDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1L8.26274 3.73726C7.47071 4.52929 7.07469 4.92531 6.61803 5.07369C6.21635 5.2042 5.78365 5.2042 5.38197 5.07369C4.92531 4.92531 4.52929 4.52929 3.73726 3.73726L1 1",
    stroke: "#054254",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgDropDownIcon);
export default __webpack_public_path__ + "static/media/Esg-DropDown-Icon.3859bda4e41d6dd18d039cbb4ec2c620.svg";
export { ForwardRef as ReactComponent };